module.exports = __webpack_public_path__ + "img/home_bg_1.1d291dcd.png";